import React from "react";
import WelcomeTitle from "./WelcomeTitle";
import CarInfo from "./CarInfo";
import { Box, Grid, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import CarImage from "./CarImage";

const useStyles = makeStyles(() => ({
  volviaContainer: {
    display: "flex",
    alignItems: "center",
  },
}));

export type WelcomeSectionProps = {
  carImageUrl?: string;
  carModel?: string;
  carYear?: string | number;
  carRegistrationNumber?: string;
  isCarModelProfile?: boolean;
  hasExclamationMark?: boolean;
  welcomeHeaderPartOneText?: string;
};

export const WelcomeSection: React.FC<WelcomeSectionProps> = (props: WelcomeSectionProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const classes = useStyles();
  const hasCarImage = !!props.carImageUrl;
  const isCarModelProfile = props.isCarModelProfile ?? false;
  const hasExclamationMark = props.hasExclamationMark ?? false;  

  if (!hasCarImage) {
    return (
      <>
         <WelcomeTitle hasExclamationMark={hasExclamationMark} hasCarImage={hasCarImage} welcomeHeaderPartOneText={props.welcomeHeaderPartOneText} />
        <hr />
         <CarInfo
          hasCarImage={hasCarImage}
          carModel={props.carModel}
          carYear={props.carYear}
          carRegistrationNumber={props.carRegistrationNumber}
          isCarModelProfile={isCarModelProfile}
        />
      </>
    );
  }

  if (isDesktop) {
    return (
      <Grid container className={classes.volviaContainer}>
        <Grid item sm={6}>
          <WelcomeTitle hasExclamationMark={hasExclamationMark} hasCarImage={hasCarImage} welcomeHeaderPartOneText={props.welcomeHeaderPartOneText} />
          <hr />
           <CarInfo
            hasCarImage={hasCarImage}
            carModel={props.carModel}
            carYear={props.carYear}
            carRegistrationNumber={props.carRegistrationNumber}
            isCarModelProfile={isCarModelProfile}
          />
        </Grid>
        <Grid item sm={6}>
          <CarImage imageUrl={props.carImageUrl as string} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container className={classes.volviaContainer}>
      <Grid item xs={12} md={6}>
        <Box display='flex' flexDirection='column'>
          <WelcomeTitle hasExclamationMark={hasExclamationMark} hasCarImage={hasCarImage} welcomeHeaderPartOneText={props.welcomeHeaderPartOneText} />
          <hr />
          <CarImage imageUrl={props.carImageUrl as string} />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
         <CarInfo
          hasCarImage={hasCarImage}
          carModel={props.carModel}
          carYear={props.carYear}
          carRegistrationNumber={props.carRegistrationNumber}
          isCarModelProfile={isCarModelProfile}
        />
      </Grid>
    </Grid>
  );
};

export default WelcomeSection;
